// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"0ac15284","897":"92ead471"}[chunkId] + ".chunk.css";
};